(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRoot(root) {
    if (!root || root.dataset.opnReady === 'true') return;
    root.dataset.opnReady = 'true';

    const revealItems = root.querySelectorAll('[data-opn-reveal]');

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.14, rootMargin: '0px 0px -6% 0px' }
      );

      revealItems.forEach((item, index) => {
        item.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`;
        observer.observe(item);
      });
    }

    if (!reduceMotion) {
      const scene = root.querySelector('[data-opn-scene]');
      const visual = root.querySelector('.opn__visual');

      if (scene && visual) {
        const moveScene = (event) => {
          const bounds = visual.getBoundingClientRect();
          const x = (event.clientX - bounds.left) / bounds.width - 0.5;
          const y = (event.clientY - bounds.top) / bounds.height - 0.5;
          scene.style.setProperty('--rx', `${(-5 - y * 13).toFixed(2)}deg`);
          scene.style.setProperty('--ry', `${(10 + x * 18).toFixed(2)}deg`);
        };

        const resetScene = () => {
          scene.style.setProperty('--rx', '-5deg');
          scene.style.setProperty('--ry', '10deg');
        };

        visual.addEventListener('pointermove', moveScene, { passive: true });
        visual.addEventListener('pointerleave', resetScene, { passive: true });
      }

      root.querySelectorAll('[data-opn-tilt]').forEach((card) => {
        const moveCard = (event) => {
          const bounds = card.getBoundingClientRect();
          const x = (event.clientX - bounds.left) / bounds.width - 0.5;
          const y = (event.clientY - bounds.top) / bounds.height - 0.5;
          card.style.setProperty('--tilt-x', `${(-y * 4.5).toFixed(2)}deg`);
          card.style.setProperty('--tilt-y', `${(x * 5.5).toFixed(2)}deg`);
          card.style.setProperty('--shine-x', `${((x + 0.5) * 100).toFixed(1)}%`);
          card.style.setProperty('--shine-y', `${((y + 0.5) * 100).toFixed(1)}%`);
        };

        const resetCard = () => {
          card.style.setProperty('--tilt-x', '0deg');
          card.style.setProperty('--tilt-y', '0deg');
          card.style.setProperty('--shine-x', '70%');
          card.style.setProperty('--shine-y', '20%');
        };

        card.addEventListener('pointermove', moveCard, { passive: true });
        card.addEventListener('pointerleave', resetCard, { passive: true });
      });
    }
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-opn-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();